import React from "react";
import SortableContainerWithoutContext from "src/components/Sortable/ContainerWithoutContext";
import { verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import SortableItem from "src/components/Sortable/Item";
import Droppable from "src/components/Sortable/Droppable";
import SortableHandle from "src/components/Sortable/Handle";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import CardActionsPrioritizationMatrix from ".";
import { IActionsMatrix } from "../../interface";

export interface IListOfCardMatrix{
    data: IActionsMatrix[];
    number: string;
	numberOfElements: number;
  }

const ListOfCardMatrix: React.FC<IListOfCardMatrix> = ({
	data,
	number,
	numberOfElements
}) => (
	<>
		<SortableContainerWithoutContext
			items={data}
			strategy={verticalListSortingStrategy}
		>
			<Droppable id={number} flexDirection="column">
				<InfiniteScrollWithoutFetch 
					defaultNumberOfElements={numberOfElements}
					manuallyToggleShowMore
					listElements={data ?? []}
					mapper={(valueItem) => (
						<React.Fragment key={valueItem.id}>
							{valueItem && valueItem.id && (
								<SortableItem id={valueItem.id} key={valueItem.inb001Id}>
									<SortableHandle>
										<CardActionsPrioritizationMatrix 
											data={valueItem} 
										/>
									</SortableHandle>
								</SortableItem>
							)}
						</React.Fragment>
					)}
				/>
			</Droppable>
		</SortableContainerWithoutContext>
	</>
);

export default ListOfCardMatrix;
